import { environment } from "./environment";

const protectedResourceMap: [string, string[]][] = [
  ["https://graph.microsoft.com/v1.0/me", ["user.read"]],
];
const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

function loggerCallback(logLevel, message, piiEnabled) {
  console.log("client logging" + message + "  " + logLevel);
}

export const msConfig = {
  clientID: environment.clientID,
  authority: `https://login.microsoftonline.com/${environment.tenantID}`,
  validateAuthority: true,
  redirectUri: environment.redirectUrl,
  cacheLocation: "localStorage",
  storeAuthStateInCookie: isIE,
  postLogoutRedirectUri: environment.logoutUrl,
  navigateToLoginRequestUrl: false,
  //consentScopes: [
  //  `api://${apiClientID}/General`
  //],
  unprotectedResources: ["https://www.microsoft.com/en-us/"],
  protectedResourceMap: protectedResourceMap,
  logger: loggerCallback,
  correlationId: "1234",
};



// WEBPACK FOOTER //
// ./src/environments/azureconfig.ts